export default "__VITE_ASSET__Czz4aAMC__"